import moment from 'moment';
moment.locale('fr');

export function formatDate(date) {
  return moment(date).format('L');
}

export function getImg(img, generique) {
  if (img) return img;
  if (generique === true) return require('@/assets/images/default_img.png');
  return require('@/assets/images/default_img.jpeg');
}
export function formatNombre(nombre) {
  const val = nombre ? nombre : 0;
  return new Intl.NumberFormat('fr', { style: 'currency', currency: 'EUR' }).format(val);
}

export function arrondiResult(value) {
  let newValue = value;
  if (newValue) {
    newValue = Math.round(newValue * 100) / 100;
  }
  return newValue;
}
export function getImgPdv(img) {
  if (img) return img;
  return require('@/assets/images/default_img.png');
}